<div id="integrationCompanySettingsDialog">
  <div class="integration-company-settings-dialog-header">
    <mat-icon
      class="integration-logo"
      [svgIcon]="integration.logo"
      aria-hidden="true"
    ></mat-icon>
    <h3 class="integration-company-settings-dialog-header-title">
      {{ integration.dialogTitle || integration.name }}
    </h3>
    <button
      type="button"
      mat-icon-button
      class="integration-company-settings-dialog-close-button"
      data-close="modal"
      aria-label="Click to close this modal"
      (click)="cancel()"
    >
      <mat-icon svgIcon="close" />
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-dialog-content>
      @if (integration.dialogHint) {
        <p
          class="integration-dialog-description"
          [class.integration-dialog-description-muted]="!integration.helpUrl"
        >
          {{ integration.dialogHint }}
          @if (integration.helpUrl) {
            <a
              class="madero-link u_clickable"
              [href]="integration.helpUrl"
              target="_blank"
              rel="noopener"
              >{{ integration.helpLabel || integration.name }}</a
            >.
          }
        </p>
      } @else {
        <p class="integration-dialog-description">
          {{ integration.description }}
        </p>

        @if (integration.helpUrl) {
          <p class="integration-dialog-help">
            Find your credentials on
            <a
              class="madero-link u_clickable"
              [href]="integration.helpUrl"
              target="_blank"
              rel="noopener"
              >{{ integration.helpLabel || integration.name }}</a
            >.
          </p>
        }
      }

      @for (field of fields; track field.key) {
        <div class="form-group tw-mb-[16px] integration-dialog-field">
          <div class="integration-dialog-field-input">
            <label
              class="tw-block tw-mb-[8px] tw-text-[14px] tw-font-semibold tw-leading-[20px]"
              [for]="'integrationField_' + field.key"
            >
              {{ field.label }}
            </label>

            <input
              class="w-100 form-control"
              [class.integration-dialog-input-masked]="isMasked(field)"
              [type]="inputType(field)"
              [id]="'integrationField_' + field.key"
              [formControlName]="field.key"
              [placeholder]="field.placeholder || field.label"
              [readonly]="isMasked(field)"
              [attr.aria-invalid]="hasError(field) ? 'true' : null"
              [attr.aria-describedby]="hasError(field) ? errorId(field) : null"
              required
            />

            @if (errorMessage(field); as error) {
              <p class="help-block text-danger" [id]="errorId(field)">
                {{ error }}
              </p>
            }
          </div>

          @if (isMasked(field)) {
            <button
              type="button"
              matButton="outlined"
              class="integration-dialog-edit button-width--fit"
              [attr.aria-label]="'Replace ' + field.label"
              (click)="edit(field)"
            >
              <mat-icon svgIcon="pencil" />
            </button>
          }
        </div>
      }
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="integration-dialog__actions">
      <button
        id="integrationCompanySettingsDialogCancelButton"
        type="button"
        matButton="outlined"
        (click)="cancel()"
      >
        Cancel
      </button>
      <button
        id="integrationCompanySettingsDialogSaveButton"
        type="submit"
        matButton="filled"
        color="primary"
        [disabled]="!canSubmit"
      >
        Save Settings
      </button>
    </mat-dialog-actions>
  </form>
</div>
